<template>
  <div class="contenitore-ricerca row row-custom">
    <div class="pannello col-xl-7 col-lg-8 col-md-11 col-sm-14 col-24 no-padding" v-loading="filtri.loading">
      <div class="header-search row row-custom">
        <div class="titolo col-22 no-padding">
          {{ filtri.titolo }}
        </div>
        <div class="chiudi col-2 no-padding">
          <icon name="elm-chiudi" scale="1" class="pointer" @click.native="closeRicerca"></icon>
        </div>
      </div>
      <div class="content-search">
        <div class="elemento col-24" v-for="(item, index) in filtri.filtri" :key="index" :style="{marginTop: (item.ifShow === false) ? '0px': ''}">
          <div v-if="((item.type !== 'select-with-object')) || ((item.type === 'select-with-object') && (item.ifShow === true))">

            <div class="search-label">
              {{ item.myLabel + ':' }}
            </div>

            <el-select v-if="(item.type === 'select')" class="col-24 no-padding custom-select-el" v-model="filtri.valueSelected[index]"
                        placeholder="" :clearable="item.ifClearable"
                        :disabled="item.ifDisabled" @change="changeValueOrClick(index)">
              <el-option v-for="option in filtri.dati[index]"
                          :label="option[item.label]"
                          :key="option[item.key]"
                          :value="option[item.value]">
              </el-option>
            </el-select>

            <el-select v-if="(item.type === 'select-with-object')" class="col-24 no-padding custom-select-el" v-model="filtri.valueSelected[index]"
                          placeholder="" :clearable="item.ifClearable" :value-key="item.key"
                          :disabled="item.ifDisabled" @change="changeValueOrClick(index)">
              <el-option v-for="option in filtri.dati[index]"
                          :label="returnOptionLabel(item.label, option)"
                          :key="option[item.key]"
                          :value="option">
              </el-option>
            </el-select>

            <el-date-picker v-if="(item.type === 'dt-picker')" :class="[(item.typePicker === 'daterange') ? 'custom-date-picker-range' : 'custom-date-picker']"
                              :format="item.format"
                              :value-format="item.valueFormat"
                              :type="item.typePicker" placeholder=""
                              v-model="filtri.valueSelected[index]"
                              :clearable="item.ifClearable"
                              range-separator=" - "
                              start-placeholder=""
                              end-placeholder=""
                              @change="changeValueOrClick(index)"
                              :picker-options="{
                                firstDayOfWeek: 1
                              }">
            </el-date-picker>

              <el-input v-if="(item.type === 'input')" class="col-24 no-padding custom-input" v-model="filtri.valueSelected[index]" placeholder=""
                      :clearable="item.ifClearable" @blur="changeValueOrClick(index)" @clear="changeValueOrClick(index)"></el-input>
                        
          </div>
        </div>

        <div class="bottoni col-24">
          <el-button @click="cerca" class="custom-button" type="primary">
            {{ $t('ricercaPanel.cerca').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="bg-oscurato col-xl-17 col-lg-16 col-md-13 col-sm-10 d-none d-sm-block no-padding"></div>
  </div>
</template>

<script>
export default {
  name: 'Ricerca',
  props: {
    filtri: {
      type: Object
    }
  },
  i18n: {
    messages: {
      it_IT: {
        ricercaPanel: {
          cerca: 'Cerca'
        }
      },
      fr_FR: {
        ricercaPanel: {
          cerca: 'Recherche'
        }
      },
      es_ES: {
        ricercaPanel: {
          cerca: 'Buscar'
        }
      },
      de_DE: {
        ricercaPanel: {
          cerca: 'Suchen'
        }
      },
      en_GB: {
        ricercaPanel: {
          cerca: 'Search'
        }
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    changeValueOrClick: function (index, value) {
      this.$emit('changeValueOrClick', index, value)
    },
    cerca: function () {
      this.$emit('cerca')
    },
    closeRicerca: function () {
      this.$emit('closeRicerca')
    },
    returnOptionLabel: function (label, option) {
      if (label.length === 1) {
        return option[label[0]]
      } else {
        return option[label[0]] + ' - ' + option[label[1]]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../assets/less/general.less";
  @import "../../assets/less/el-select.less";
  @import "../../assets/less/el-date-picker.less";
  @import "../../assets/less/el-input.less";
  @import "../../assets/less/el-button.less";

  .contenitore-ricerca {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    .bg-oscurato {
      height: 100%;
      background-color: #5d5d5d;
      opacity: 0.7;
    }
    .pannello {
      height: 100%;
      background-color: @white;
      opacity: 1;
      overflow: auto;
      z-index: 10;
      .header-search {
        margin-top: 5px;
        line-height: 20px;
        padding: 0 15px;
        width: 100%;
        .chiudi {
          text-align: right;
        }
        .titolo {
          .set-font(@color: @oroRiva, @size: 24px, @weight: bold, @family: 'os-lightitalic');
          letter-spacing: 2px;
          padding-top: 5px;
        }
      }
      .content-search {
        margin-top: 25px;
        .elemento {
          margin-top: 10px;
          .search-label {
            .set-font(@size: 12px; @color: @greenRiva; @family: 'os-semibold');
            text-transform: uppercase;
            letter-spacing: 1px;
          }
        }
        .bottoni {
          text-align: right;
          margin-top: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/RicercaPanel.vue